import React from "react";
import DependencyValidator from "../dependency-validator";

import { Container, TitleEl, Subtitle, Circle } from "./styles";

type IProps = any & {
  title: string;
  subtitle?: string;
  textColorBlack?: boolean;
  images?: string | undefined;
  number: number;
};

const Title: React.FC<IProps> = ({
  title,
  subtitle = "",
  textColorBlack = false,
  images,
  number,
  ...el
}: IProps) => (
  <DependencyValidator {...el}>
    <Container {...el}>
      {number && <Circle>{number}</Circle>}
      <TitleEl>{title}</TitleEl>
      &nbsp;
      <div>
        <Subtitle style={{ color: textColorBlack && "black" }}>
          {subtitle}
        </Subtitle>
        {images && <img src={images} alt="Imagem" />}
      </div>
    </Container>
  </DependencyValidator>
);

export default Title;
